import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Card,
  CardContent,
  Typography,
  CircularProgress,
  Box,
} from "@mui/material";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function UserUsageDashboard({isLoggedIn}) {
  const navigate = useNavigate(); 
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!isLoggedIn) {
      navigate("/"); // or any auth page you have
    }
    const fetchUsageInfo = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/user-usage-info`,
        );
        setData(res.data);
      } catch (err) {
        console.error("Failed to fetch user usage info", err);
      } finally {
        setIsLoading(false);
      }
    };
    fetchUsageInfo();
  }, []);

  if (isLoading || !data) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
        width="100%"
      >
        <CircularProgress />
      </Box>
    );
  }

  const usageChartData = Object.entries(data.usage)
    .filter(([key]) => key !== "total_usage_count")
    .map(([tool, count]) => ({ name: tool.replace(/_/g, " "), count }))
    .sort((a, b) => b.count - a.count);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-4">
      <Card className="col-span-1 md:col-span-2">
        <CardContent>
          <Typography variant="h5" gutterBottom align="center">
            User Subscription Overview
          </Typography>
          <Box display="flex" justifyContent="center" mt={2}>
            <TableContainer component={Paper} sx={{ width: "60%" }}>
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell>
                      <strong>Plan</strong>
                    </TableCell>
                    <TableCell>{data.subscription.plan}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <strong>Account Type</strong>
                    </TableCell>
                    <TableCell>{data.subscription?.account_type?.toUpperCase()}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <strong>Total Credits</strong>
                    </TableCell>
                    <TableCell>{data.subscription.total_credits}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <strong>Availed Credits</strong>
                    </TableCell>
                    <TableCell>{data.subscription.availed_credits}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <strong>Remaining Credits</strong>
                    </TableCell>
                    <TableCell>{data.subscription.remaining_credits}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </CardContent>
      </Card>

      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom align="center">
            Tool wise usage of credits
          </Typography>
          <Box display="flex" justifyContent="center" mt={2}>
            <Box sx={{ width: "70%", height: 400 }}>
              <ResponsiveContainer width="100%" height="100%">
                <BarChart data={usageChartData} layout="horizontal">
                  <XAxis
                    type="category"
                    dataKey="name"
                    tick={false}
                    axisLine={true}
                    tickLine={true}
                  />
                  <YAxis allowDecimals={false} />
                  <Tooltip
                    formatter={(value, name, props) => [
                      `${value} uses`,
                      props.payload.name,
                    ]}
                  />
                  <Bar dataKey="count" fill="#8884d8" radius={[4, 4, 0, 0]} />
                </BarChart>
              </ResponsiveContainer>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </div>
  );
}
